import React from 'react'
import { useAppSelector } from '../../../../store/hooks'
import { selectAccountId } from '../../../../store/auth/authSlice'
import { useGetAllEmailTypesQuery } from '../../../../store/integrations/emailTypes'
import { useGetAllDocumentTypesQuery } from '../../../../store/ai/documentTypes'
import { RawReferenceFallback } from './RawReferenceFallback'
import { ReferencePicker } from './ReferencePicker'
import { MeetingTemplateWidget } from './MeetingTemplateWidget'
import { toOptions } from './referenceOptions'
import { EMAIL_TYPE_KIND_BY_IPH_TYPE, isEmailIphType, isIphType, isMeetingTemplateIphType } from './iphBindings'
import type { ZocksReferenceWidgetProps } from './registry'

interface EmailTypePickerProps extends ZocksReferenceWidgetProps {
  iphType: keyof typeof EMAIL_TYPE_KIND_BY_IPH_TYPE
}

const EmailTypePicker: React.FC<EmailTypePickerProps> = ({ iphType, ...props }) => {
  const accountId = useAppSelector(selectAccountId)
  const { data, isLoading } = useGetAllEmailTypesQuery({ accountId, includeInactive: false, kind: EMAIL_TYPE_KIND_BY_IPH_TYPE[iphType] })
  return <ReferencePicker {...props} options={toOptions(data?.data)} loading={isLoading} />
}

const DocumentTypePicker: React.FC<ZocksReferenceWidgetProps> = (props) => {
  const accountId = useAppSelector(selectAccountId)
  const { data, isLoading } = useGetAllDocumentTypesQuery({ accountId, includeInactive: false })
  return <ReferencePicker {...props} options={toOptions(data?.data)} loading={isLoading} />
}

export const IphTemplateWidget: React.FC<ZocksReferenceWidgetProps> = (props) => {
  const iphType = typeof props.config.iphType === 'string' ? props.config.iphType : ''

  if (!isIphType(iphType)) {
    return <RawReferenceFallback {...props} reason={iphType ? `Unknown IPH type "${iphType}"` : 'Missing IPH type'} />
  }

  if (isEmailIphType(iphType)) {
    return <EmailTypePicker {...props} iphType={iphType} />
  }

  if (isMeetingTemplateIphType(iphType)) {
    return <MeetingTemplateWidget {...props} />
  }

  return <DocumentTypePicker {...props} />
}
